import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Campaign } from '../../model/campaign/Campaign';

export interface ISelectedCampaign {
    campaign?: Partial<Campaign>;
    activeCampaignId?: number | undefined;
    isChildCampaign?: boolean;
    isAclLoaded?: boolean;
}

const activeCampaignId = sessionStorage.getItem('activeCampaignId');

const initialSelectedCampaignSlice: ISelectedCampaign = {
    campaign: undefined,
    activeCampaignId: activeCampaignId ? +activeCampaignId : undefined,
    isChildCampaign: false,
    isAclLoaded: false,
};

export const selectedCampaignSlice = createSlice({
    name: 'selectedCampaign',
    initialState: initialSelectedCampaignSlice,
    reducers: {
        setActiveCampaign: (state: ISelectedCampaign, { payload: campaign }: PayloadAction<Campaign | undefined>) => {
            state.campaign = campaign;
            state.isChildCampaign = !!campaign?.parent;
            return state;
        },
        setActiveCampaignId: (state, { payload: id }: PayloadAction<string | undefined>) => {
            state.activeCampaignId = id ? +id : undefined;
            return state;
        },
        setIsAclLoaded: (state, { payload: value }: PayloadAction<boolean | undefined>) => {
            state.isAclLoaded = value;
            return state;
        },
        setCanSkipReporting: (state, action) => {
            state.campaign = { ...state.campaign, canSkipReporting: action.payload };
            return state;
        },
        setIsReviewed: (state, action) => {
            const isReviewed = action.payload;
            state.campaign = { ...state.campaign, isReviewed };
            return state;
        },
    },
});
